<template>
	<div class="chat-chat-search-box">
		<div class="chat-chat-search-search">
			<select v-model="param.fansType">
				<option value="">类别</option>
				<option value="W">W</option>
				<option value="L">L</option>
				<option value="C">C</option>
				<option value="S">S</option>
			</select>
			<input type="text" placeholder="标签" v-model="param.tag">
			<input type="text" placeholder="昵称/群名" v-model="param.keyword" id="cc-keyword" @keyup.enter="search" autocomplete="off">
			<button type="button" @click="search">搜索</button>
			<button type="button" class="chat-chat-search-close" @click="close">关闭</button>
		</div>
		<div class="chat-chat-search-fans">
			<div class="chat-chat-search-wrap" id="chat-chat-search-wrap"  @scroll="chatScroll">
				<!-- 普通粉丝列表显示 -->
				<div class="chat-chat-search-lable" v-if="fansList.length > 0">联系人</div>
				<div class="chat-chat-search-items" v-if="fansList.length > 0">
					<div class="chat-chat-search-item" v-for="(fans,key) in fansList" :key="'chat-chat-search-fans-'+fans.id" :class="{'chat-chat-search-item-active':currentFans.id == fans.id}"
					 @click="chatClick(fans,1)" v-if="showAllFans ? true : key < 5">
						<div class="chat-chat-search-avatar">
							<img :src="fans.wx_photo" :title="fans.wx_name">
						</div>
						<div class="chat-chat-search-info">
							<div class="chat-chat-search-title">{{fans.wx_name}}</div>
							<div class="chat-chat-search-desc">{{fans.con_remark}}</div>
						</div>
					</div>
				</div>
				<div class="chat-chat-search-showall" v-if="fansList.length > 5 && !showAllFans" @click="showAllFans = true">
					显示全部（{{fansList.length}}）
				</div>
				<!-- 群列表显示 -->
				<div class="chat-chat-search-lable" v-if="clusterList.length > 0" style="border-left: 3px solid #d96a33;">群聊</div>
				<div class="chat-chat-search-items" v-if="clusterList.length > 0">
					<div class="chat-chat-search-item" v-for="(cluster,key) in clusterList" :key="'chat-chat-search-cluster-'+cluster.id"
					 :class="{'chat-chat-search-item-active':currentFans.id == cluster.id}" @click="chatClick(cluster,2)" v-if="showAllCluster ? true : key < 5">
						<div class="chat-chat-search-avatar">
							<img :src="cluster.cluster_photo | connectHost" :title="cluster.cluster_name">
						</div>
						<div class="chat-chat-search-info">
							<div class="chat-chat-search-title">{{cluster.cluster_name}}</div>
						</div>
					</div>
				</div>
				<div class="chat-chat-search-showall" v-if="clusterList.length > 5 && !showAllCluster" @click="showAllCluster = true">
					显示全部（{{clusterList.length}}）
				</div>
				<!-- 显示更多 -->
				<div class="chat-chat-search-lable" v-if="showMore && param.keyword !== ''" style="border-left: 3px solid #1eaac5;">更多</div>
				<div class="chat-chat-search-items" v-if="showMore && param.keyword !== ''">
					<div class="chat-chat-search-item" @click="goHistory">
						<div class="chat-chat-search-avatar chat-chat-search-avatar-more">
							<img src="../../assets/img/search-white.png">
						</div>
						<div class="chat-chat-search-info">
							<div class="chat-chat-search-title">搜索更多聊天记录</div>
							<div class="chat-chat-search-desc">关于“{{param.keyword}}”的本地聊天记录</div>
						</div>
					</div>
				</div>
				<!-- 数据加载提示 -->
				<div class="chat-chat-search-loadding" v-if="!isEnd">
					<img src="/img/loading.gif" alt="">
					<span>数据加载中...</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getSearchFansList,
		getSearchClusterList
	} from '../../network/local/search.js'
	import {getRecentlyByFIdAndType} from '../../network/local/recently.js'

	export default {
		name: 'ChatChatSearch',
		props: {},
		data() {
			return {
				param: {
					fansType: '',
					tag: '',
					keyword: '',
				},
				isEnd: true,
				showAllFans: false,
				showAllCluster: false,
				fansList: [],
				clusterList: [],
				currentFans: {},
				scrollTop: 0,
				showMore: false
			}
		},
		methods: {
			// 初始化部分数据
			init() {
				this.isEnd = true
				this.scrollTop = 0
				this.fansList = []
				this.clusterList = []
				this.currentFans = {}
				this.showAllFans = false
				this.showAllCluster = false
				this.showMore = false
			},

			// 搜索
			search() {
				this.isEnd = false
				this.init()
				getSearchFansList(0, this.param, data => {
					this.fansList = data
					getSearchClusterList('', this.param, c_data => {
						this.clusterList = c_data
						this.isEnd = true
						this.showMore = true
					})
				})
			},

			// 列表点击
			chatClick(fans, type) {
				this.currentFans = fans
				let emitData = {}
				if(type == 1){
					getRecentlyByFIdAndType(fans.id,1,cData=>{
						emitData = {
							"id": fans.id,
							"account_open_id": "",
							"friends_open_id": fans.open_id,
							"friend_or_cluster_id": fans.id,
							"friend_img": fans.wx_photo,
							"friend_name": fans.wx_name,
							"chat_type": type,
							"is_search": 1
						}
						if(cData !== false){
							emitData.is_collect = cData.is_collect
							emitData.is_top = cData.is_top
							emitData.chatting_id = cData.id
						}else{
							emitData.is_collect = 0
							emitData.is_top = 0
							emitData.chatting_id = 0
						}
						this.$emit('chat-click',emitData)
					})
					
				}else{
					emitData = {
						"id": fans.id,
						"account_open_id": fans.open_id,
						"friends_open_id": fans.wechat_cluster_id,
						"friend_or_cluster_id": fans.id,
						"friend_img": fans.cluster_photo,
						"friend_name": fans.cluster_name,
						"chat_type": type
					}
					this.$emit('chat-click',emitData)
				}
			},

			// 关闭搜索
			close() {
				this.$emit('search-show-call', false)
			},
			
			// 关闭搜索
			goHistory() {
				if(this.param.keyword !== undefined && this.param.keyword !== ''){
					this.$emit('search-keyword', this.param.keyword+'------'+(new Date()).getTime())
				}
			},
			
			// 滚动刷新数据
			chatScroll(event){
				let page = document.getElementById("chat-chat-search-wrap")
				this.scrollTop = page.scrollTop
			},
		},

		// 只有组件被缓存时，才会调用这2个方法
		activated() {
			let page = document.getElementById("chat-chat-search-wrap")
			page.scrollTop = this.scrollTop
		},
		
		mounted() {
			// 自动聚焦
			let obj = document.getElementById("cc-keyword")
			if(obj !== null){
				obj.focus()
			}
		}
	}
</script>
<style>
	.chat-chat-search-box {
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.chat-chat-search-box .chat-chat-search-search {
		width: 100%;
		padding: 0 10px;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		box-sizing: border-box;
	}

	.chat-chat-search-search select {
		width: 60px;
		height: 28px;
		border: 1px solid #CFCFCF;
		color: #888888;
	}

	.chat-chat-search-search input {
		display: block;
		height: 26px;
		line-height: 26px;
		width: 80px;
		border: 1px solid #CFCFCF;
		font-size: 12px;
		padding: 0 4px;
		color: #888888;
		margin-left: 4px;
		border-radius: 2px;
	}

	.chat-chat-search-search button {
		height: 28px;
		line-height: 28px;
		padding: 0 6px;
		cursor: pointer;
		background-color: #009688;
		color: #FFFFFF;
		margin-left: 4px;
		font-size: 12px;
		border-radius: 2px;
	}

	.chat-chat-search-search .chat-chat-search-close {
		background-color: #ec0f0f;
	}

	.chat-chat-search-box .chat-chat-search-fans {
		position: absolute;
		top: 50px;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}

	.chat-chat-search-fans .chat-chat-search-wrap {
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.chat-chat-search-wrap::-webkit-scrollbar-thumb:hover {
		background: #868686;
	}

	.chat-chat-search-wrap .chat-chat-search-items {
		width: 100%;
		height: auto;
	}

	.chat-chat-search-wrap .chat-chat-search-lable {
		height: 30px;
		line-height: 30px;
		padding: 0 17px;
		background-color: #d3d3d3;
		color: #888888;
		border-left: 3px solid #1cb75e;
	}

	.chat-chat-search-showall {
		height: 26px;
		line-height: 26px;
		padding: 0 20px;
		color: #42B983;
		font-size: 12px;
		cursor: pointer;
	}

	.chat-chat-search-items .chat-chat-search-item {
		width: 100%;
		height: 62px;
		padding: 10px 20px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		cursor: pointer;
		overflow: hidden;
		box-sizing: border-box;
	}

	.chat-chat-search-items .chat-chat-search-item:hover {
		background-color: #e2e2e2;
	}

	.chat-chat-search-items .chat-chat-search-item-active {
		background-color: #e2e2e2;
	}

	.chat-chat-search-item .chat-chat-search-avatar {
		width: 42px;
		height: 42px;
		position: relative;
		text-align: center;
		line-height: 42px;
	}
	.chat-chat-search-item .chat-chat-search-avatar-more{
		background-color: #42B983 !important;
		border-radius: 2px !important;
	}
	.chat-chat-search-avatar img {
		width: 42px;
		height: 42px;
		border-radius: 2px;
		overflow: hidden;
	}
	.chat-chat-search-avatar-more > img{
		width:20px;height: auto;
	}
	.chat-chat-search-item .chat-chat-search-info {
		width: 0;
		height: 40px;
		padding: 1px 0;
		margin-left: 10px;
		text-align: left;
		flex-grow: 1;
		display: flex;
		justify-content: center;
		flex-direction: column;
	}
	.chat-chat-search-info .chat-chat-search-title,.chat-chat-search-info .chat-chat-search-desc {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #27354A;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		width: 100%;
	}
	.chat-chat-search-info .chat-chat-search-desc {
		color: #999999 !important;
	}
	.chat-chat-search-loadding {
		height: 36px;
		line-height: 36px;
		text-align: center;
		color: #42B983;
	}

	.chat-chat-search-loadding>* {
		display: inline-block;
		vertical-align: middle;
	}

	.chat-chat-search-loadding img {
		margin-right: 5px;
	}
</style>
